module.exports = __webpack_public_path__ + "static/Forager-treehouse-5d4849947e698d482d5d89657f89bf74.webp";